import { actions } from './partner_doctor_report/actions'
import { getters } from './partner_doctor_report/getters'
import { state } from './partner_doctor_report/state'
import { mutations } from './partner_doctor_report/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}